/* eslint-disable prettier/prettier */
import { Carousel } from '@fancyapps/ui/dist/carousel/carousel.esm.js';
import '@fancyapps/ui/dist/carousel/carousel.css';

class RankingWidget extends HTMLElement {
  static observedAttributes = ['slug', 'website', 'preview'];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.configs = {
      apiEndpoint: 'https://staging-cms.weekendhk.com',
      resourcePrefix: 'http://localhost:3000',
      slug: '',
      website: '',
      preview: false,
      previewPageId: 0,
    };
    if (process.env.NEXT_PUBLIC_STRAPI_URL) {
      this.configs.apiEndpoint = process.env.NEXT_PUBLIC_STRAPI_URL;
    }
    if (process.env.NEXT_PUBLIC_RESOURCE_PREFIX) {
      this.configs.resourcePrefix = process.env.NEXT_PUBLIC_RESOURCE_PREFIX;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(`attributeChangedCallback: ${name} = ${newValue}`);

    const self = this;
    if (name === 'slug') {
      this.configs.slug = newValue;
      if (newValue && oldValue !== newValue) {
        // have to delay wait website attr
        setTimeout(function() {
          self.initApp();
        }, 20);
      }
    } else if (name === 'website') {
      this.configs.website = newValue;
    } else if (name === 'preview') {
      this.configs.preview = !!newValue;
    }
  }

  connectedCallback() {
    // this.initApp();
  }

  async initApp() {
    try {
      // clear content
      this.shadowRoot.innerHTML = '';

      console.log(`InitRankingWidget`, this.configs);

      if (this.configs.website) {
        const showWidget = await this.checkWebsiteShowWidget();
        if (!showWidget && !this.configs.preview) {
          return;
        }
      }

      this.loadCss();

      const data = await this.loadRemoteData();

      this.renderHTML(data);
    } catch (err) {
      console.error(err);
    }
  }

  async checkWebsiteShowWidget(website) {
    const resp = await fetch(
      `${this.configs.apiEndpoint}/api/ranking-widget-placement?populate[web_homepage_placement][populate][ranking_widget][fields][0]=page_slug`
    );

    if (!resp.ok) {
      return false;
    }

    const data = await resp.json();

    // console.log('checkWebsiteShowWidget', data);
    if (!data.data.attributes.web_homepage_placement) {
      return false;
    }

    const placement = data.data.attributes.web_homepage_placement;

    if (placement.ranking_widget) {
      if (placement.ranking_widget.data.attributes.page_slug) {
        const attrs = placement.ranking_widget.data.attributes;
        this.configs.slug = attrs.page_slug;
        this.configs.previewPageId = placement.ranking_widget.data.id;
        // console.log(`change slug to: ${this.configs.slug}`)
      }
    }

    return !!placement.display;
  }

  loadCss() {
    const cssUrl = `${this.configs.resourcePrefix}/web-components.css`;
    const linkElem = document.createElement('link');
    linkElem.setAttribute('rel', 'stylesheet');
    linkElem.setAttribute('href', cssUrl);
    this.shadowRoot.appendChild(linkElem);
  }

  async loadRemoteData() {
    let requestUrl;
    if (this.configs.preview && this.configs.previewPageId) {
      requestUrl = `${this.configs.apiEndpoint}/api/pages/${encodeURIComponent(this.configs.previewPageId)}`;
    } else {
      requestUrl = `${this.configs.apiEndpoint}/api/pageslug?page_slug=${encodeURIComponent(this.configs.slug)}`;
    }
    const resp = await fetch(requestUrl);

    if (!resp.ok) {
      throw new Error(
        `NMG Ranking widget loading issue: code = ${resp.status}`
      );
    }

    const data = await resp.json();

    // console.log('Data loaded: ', data);

    return data;
  }

  renderHTML(data) {
    const multipleList = this._getMultipleListComponent(data);
    if (!multipleList) {
      return;
    }

    this.shadowRoot.innerHTML += 
    `${this.renderCSS(multipleList)}
      <div class="container">
        <div class="bg-container">
          ${this.renderHeader(multipleList)}
          <div class="cards-container-wrap">
            <div class="cards-container" id="cards-container">
              ${this.renderCards(multipleList)}
            </div>
          </div>
        </div>
      </div>`;

    this.initCarousel();

    this.triggerGATracking(multipleList);
  }

  async initCarousel() {
    const container = this.shadowRoot.getElementById('cards-container');

    const options = {
      infinite: false,
      Navigation: false,
      Dots: {
        minCount: 4,
      },
    };

    new Carousel(container, options);
  }

  triggerGATracking(multipleList) {
    const trackingData = {
      item_name: 'item名字',
      item_list_name: 'list名字',
      item_url: 'http://www.g.cn'
    }

    console.log(`triggerGATracking, window.add_themes_ga4_tracking = ${
      window.add_themes_ga4_tracking
    }, this.shadowRoot.add_themes_ga4_tracking = ${
      this.shadowRoot.add_themes_ga4_tracking
    }`, trackingData);

    if (!window.add_themes_ga4_tracking) {
      return;
    }

    window.add_themes_ga4_tracking('Ranking_Widget_List_item_impression', trackingData);
  }

  renderHeader(data) {
    const { header } = data;
    if (!header) {
      return '';
    }

    const { logo } = header;

    const desktopImage = this._getImage(logo.desktop_image);

    return `<div class="header">
        <img class="header-icon" src="${desktopImage.src}" />
        <div class="header-desc">${header.description}</div>
      </div>`;
  }

  renderCards(data) {
    const list = data.multi_list_ranking_section
    if (!list) {
      return '';
    }

    let ret = '';

    for (let i = 0; i < list.ranking_list_blocks.length; i++) {
      const item = list.ranking_list_blocks[i];
      ret += this.renderCardItem(item);
    }

    return ret;
  }

  renderCardItem(item) {
    const desktopImage = this._getImage(item.banner_image.desktop_image);
    const maxDetailsCount = item.ranking_list_items_setting.num_of_items_per_list;
    const rankingListAttrs = item.ranking_list.data.attributes;

    const rankingItems = [];
    for (let i = 0; i < rankingListAttrs.ranking_items.length; i++) {
      if (i >= maxDetailsCount) {
        break;
      }

      const rankingItem = rankingListAttrs.ranking_items[i];
      rankingItems.push(rankingItem);
    }

    const rankingIconsMap = {
      0: this._getImage(rankingListAttrs.gold_batch_image),
      1: this._getImage(rankingListAttrs.silver_batch_image),
      2: this._getImage(rankingListAttrs.bronze_batch_image),
    };
    const otherRankingIcon = this._getImage(rankingListAttrs.other_batch_image);

    const showMoreBtn = item.show_more_button;

    return `<div class="card-item f-carousel__slide">
      <div class="card">
        <img class="card-banner" src="${desktopImage.src}" alt="">
        <div class="card-content">
          ${this.renderCardItemDetails(
            item,
            rankingItems,
            rankingIconsMap,
            otherRankingIcon
          )}
        </div>
        <div class="card-bottom"
          style="display: ${
            showMoreBtn && showMoreBtn.visible ? 'auto' : 'none'
          }">
          <a href="${
            showMoreBtn && showMoreBtn.url ? showMoreBtn.url : '#'
          }" class="more-button" target="_blank">${
            showMoreBtn && showMoreBtn.text ? showMoreBtn.text : '更多'
          }</a>
        </div>
      </div>
    </div>`;
  }

  renderCardItemDetails(cardItem, rankingItems, rankingIconsMap, otherRankingIcon) {
    let ret = '';

    rankingItems.forEach((item, index) => {
      const statusIcon = this._getImage(
        item.rank_status_icon.data.attributes.image
      );

      let rankingIcon = otherRankingIcon.src;
      if (rankingIconsMap[index]) {
        rankingIcon = rankingIconsMap[index].src;
      }

      const avatar = this._getImage(item.icon);

      if (item.url) {
        ret += `<a class="card-details link_click" href="${item.url}" target="_blank" data_event_name="Ranking_Widget_List_item_click" data_item_name="${item.url}" data_item_list_name="${cardItem.name}"  data_item_url="${item.url}">`;
      } else {
        ret += `<div class="card-details">`;
      }

      ret += `<img class="status-ic" src="${statusIcon.src}" />
          <div class="ranking-ic-container">
            <img class="ranking-ic" src="${rankingIcon}" />${index >= 3 ? `<span>${index + 1}</span>` : ''}
          </div>
          <div class="card-details-content">
            <p class="name">${item.title}</p>
            <p class="addr">${item.subtitle || ''}</p>
          </div>
          <img class="avatar-ic" src="${avatar.src || ''}" alt="${item.title}" style="opacity: ${avatar.src ? '1' : '0'}">`;

      if (item.url) {
        ret += `</a>`;
      } else {
        ret += `</div>`;
      }
    });

    return ret;
  }

  renderCSS(data) {
    const bgComp = data.background;
    if (!bgComp) {
      return '';
    }

    const layoutMaxWidth = 1222;
    const horizontalBGPadding = 40;

    return `
      <style>
        :host {
          font-family: "Noto Sans TC",arial, microsoft jhenghei, ms gothic, malgun gothic, SimHei, microsoft yahei !important;
          display: block;
          background-color: ${bgComp.background_color}
        }
        
        a {
          underline: none;
        }

        .container {
          margin: 0px auto;
          padding: 20px 0px;
          max-width: ${layoutMaxWidth}px;
          position: relative;
        }

        .bg-container:after {
          content: '';
          display: block;
          width: ${layoutMaxWidth + horizontalBGPadding * 2}px;
          height: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          background-color: ${bgComp.background_color};
          position: absolute;
          top: 0;
          left: -${horizontalBGPadding}px;
          z-index: -1;
          border-radius: 10px;
        }

        .header {
          text-align: center;
          margin: 20px auto;
          padding: 0 0.75rem;
        }
        
        .header .header-icon {
          display: block;
          height: auto;
          width: auto;
          max-width: 100%;
          margin: 20px auto;
        }

        .header .header-desc {
          margin: 20px auto;
        }
        
        .cards-container-wrap {
          // position: absolute;
          // left: -0.75rem;
          // width: 100vw;
        }

        .cards-container {
          display: flex;
          flex-wrap: wrap;
        }

        .card-item {
          width: 340px;
          margin-bottom: 10px;
          margin-right: 10px;
        }
        .card-item:first-child {
          // margin-left: 0.75rem;
        }
        .card-item:last-child::after {
          // content: '';
          // display: block;
          // width: 0.75rem;
          // height: 100%;
        }

        .card {
          width: 100%;
          background-color: #fff;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #FFC6A5;
          // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .card img {
          display: block;
        }

        .card .card-banner {
          width: 100%;
          height: auto;
        }

        .card-content {
          padding: 0px 15px 0px 15px;
        }

        .card-details {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          border-bottom: 1px dashed #E3E3E3;
          text-decoration: none;
        }

        .card-details:last-child {
          border-bottom: none;
        }

        .card-details .status-ic {
          width: 18px;
          height: auto;
          margin-right: 14px;
        }

        .card-details .ranking-ic-container {
          width: 28px;
          margin-right: 14px;
          position: relative;
          margin-right: 14px;
        }

        .card-details .ranking-ic {
          width: 100%;
          height: auto;
        }

        .card-details span {
          text-align: center;
          width: 100%;
          line-height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          color: #FFF;
        }

        .card-details .avatar-ic {
          width: 45px;
          height: 45px;
          margin-left: 10px;
          border-radius: 5px;
        }

        .card-details .card-details-content {
          flex: 1;
          min-height: 65px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .card-details .card-details-content p {
          margin: 0;
          padding: 0;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          text-align: left;
          line-height: normal;
        }

        .card-details .card-details-content .name {
          font-size: 16px;
          font-weight: 700;
          color: #333;
          margin: 10px 0 0 0;
        }

        .card-details .card-details-content .addr {
          font-size: 13px;
          color: #807F7E;
          margin-bottom: 10px;
        }

        .card-bottom {
          padding: 8px 15px 12px 15px;
        }

        .card-bottom  .more-button {
          background-color: #FF5E00;
          color: #fff;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          display: block;
          width: 100%;
          text-align: center;
          text-decoration: none;
          font-size: 16px;
          font-weight: 700;
          line-height: 34px;
          margin: 0 auto;
        }

        .f-carousel__dots {
          bottom: -10px;
        }
        
        .f-carousel__dots .f-carousel__dot {
          width: 10px;
          height: 10px;
          background-color: #bbb;
          border-radius: 50%;
          margin: 0 5px;
          cursor: pointer;
          border: none;
          outline: none;
        }

        .f-carousel__dots .is-current .f-carousel__dot {
          background-color: #ff4500; /* 设置当前 dot 的背景颜色 */
        }

        .f-carousel {
          position: relative;
          padding: 0;
        }
        .f-carousel::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 0.75rem;
          height: 100%;
        }
        .f-carousel::after {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 0.75rem;
          height: 100%;
        }
        .f-carousel__viewport {
          padding-left: 0.75rem;
          padding-right: 0.75rem;
        }

        @media (min-width: 768px) {
          .header .header-icon {
            height: 47px;
          }
          .card-item {
            width: 394px;
            margin-bottom: 20px;
            margin-right: 20px;
          }

          .f-carousel__viewport {
            padding-left: 0;
            padding-right: 0;
          }
        }
      </style>
    `;
  }

  _getMultipleListComponent(data) {
    const { attributes: attrs } = data.data;
    for (let i = 0; i < attrs.template.length; i++) {
      const t = attrs.template[i];

      if (t.__component === 'ranking-widget.multi-list-ranking-widget-template') {
        return t;
      }
    }

    return null;
  }

  _getComponentByName(data, name) {
    const { attributes: attrs } = data.data;
    for (let i = 0; i < attrs.template.length; i++) {
      const t = attrs.template[i];

      if (t.__component === name) {
        return t;
      }
    }

    return null;
  }

  _getImage(data) {
    const ret = {
      w: 0,
      h: 0,
      src: '',
    }

    if (!data || !data.data || !data.data.attributes) {
      return ret;
    }

    const attrs = data.data.attributes;

    ret.w = attrs.width;
    ret.h = attrs.height;
    ret.src = attrs.url;

    return ret;
  }
}

customElements.define('nmg-ranking-widget', RankingWidget);
